import * as React from 'react';
import { Avatar, Table, Tooltip, Button } from 'antd';
import { User, AppState } from 'src/store';
import { Subscription, Observable } from 'rxjs';
import { QuerySnapshot, Query } from '@firebase/firestore-types';
import * as firebase from 'firebase/app';
import { ColumnProps } from 'antd/lib/table';
import ButtonGroup from 'antd/lib/button/button-group';
import { Dispatch, connect } from 'react-redux';
import { push } from 'react-router-redux';

const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
      navigate: (route: string) => {
        dispatch(push(route));
      },
      onResetPassword: (merchantId: string, id: string) => { dispatch(push(`/merchants/${merchantId}/users/resetpassword/${id}`)); },
    };
  };
  
interface Props {
    merchantId: string;
    navigate: (route: string) => void;
    onResetPassword: (merchantId: string, id: string) => void;
}

interface S {
    data: User[];
    loading?: boolean;
    currentPage: number;
}

class UserList extends React.Component<Props, S> {
    subscription: Subscription;
    columns: ColumnProps<User>[];
    queryRef: Query;
    pageSize: number;
    constructor(props: Props) {
        super(props);

        this.subscription = new Subscription();
        const { merchantId } = this.props;
        this.pageSize = 10;
        this.state = { data: [], loading: false, currentPage: 1 };
        this.queryRef = firebase.firestore().doc(`merchants/${merchantId}`)
            .collection('users')
            .orderBy('createdOn', 'desc');
    }

    componentDidMount() {
        this.handlePageChange(1);
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    handlePageChange = (page: number) => {
        const paginatedRef = this.queryRef;
        this.setState({ loading: true });
        // if (page > 1) {
        //     paginatedRef = this.queryRef.endAt(page);
        // }

        const members$ = new Observable<QuerySnapshot>(observer => {
            return paginatedRef.onSnapshot(sn => observer.next(sn));
        });

        this.subscription = members$.subscribe(sn => {
            if (!sn.empty) {
                const data = sn.docs.map(d => ({ ...d.data(), id: d.id } as User));
                this.setState({ data, loading: false, currentPage: page });
            } else {
                this.setState({ data: [], loading: false, currentPage: page });
            }
        });
    }

    getDataSource = () => {
        const { data, loading, currentPage } = this.state;
        const page = loading ? 1 : currentPage;
        const ds = !loading ?
            data.map((obj, i) => ({
                no: ((page - 1) * this.pageSize) + (i + 1),
                key: obj.id,
                ...obj,
            })) : [];

        return {
            ds,
            page,
        };
    }
    render() {
        const { page, ds } = this.getDataSource();
        const { loading } = this.state;
        const { onResetPassword, merchantId } = this.props;
        this.columns = [{
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            width: "5%",
            render: (text: string, record: User, index: number) => {
                return <span>{record.no}</span>;
            }
        },
        {
            title: 'Image',
            dataIndex: 'imageName',
            key: 'imageName',
            width: "10%",
            // tslint:disable-next-line:no-any
            render: (text: string, record: User) => (
                <span>
                    <Avatar
                        src={record.photo}
                        className="img-circle"
                    />
                </span>
            )
        },
        {
            title: 'Display Name',
            dataIndex: 'displayName',
            key: 'displayName',
            width: '20%',
        },
        {
            title: 'Login Name',
            dataIndex: 'loginUserName',
            key: 'loginUserName',
            width: '20%',
        },
        {
            title: 'Phone',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            width: '15%',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: '15%',
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'rolw',
            width: '15%',
        }, {
            title: 'Action',
            key: 'action',
            width: '40%',
            render: (text: string, record: User) => (
                <ButtonGroup>
                    {/* <Tooltip
                        placement="top"
                        title="Click to Edit User"
                    >
                        <Button
                            icon="edit"
                            onClick={() => { onUserEdit(record.id); }}
                        >
                            Edit
                        </Button>
                    </Tooltip> */}
                    <Tooltip
                        placement="top"
                        title="Click to Reset User Password"
                    >
                        <Button
                            icon="unlock"
                            // tslint:disable-next-line:jsx-no-lambda
                            onClick={() => { onResetPassword(merchantId, record.id); }}
                        >
                            Reset Password
                        </Button>
                    </Tooltip>
                    {/* <Popconfirm
                        title="Are you sure delete this user?"
                        onConfirm={() => { onUserDelete(record.id); }}
                        // onCancel={cancel} 
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip
                            placement="top"
                            title="Click to Delete User"
                        >
                            <Button
                                icon="delete"
                            >
                                Delete
                        </Button>
                        </Tooltip>
                    </Popconfirm> */}
                </ButtonGroup>
            ),
        }
            // {
            //     title: 'Created',
            //     dataIndex: 'creat',
            //     width: '15%',
            //     // tslint:disable-next-line:no-any
            //     render: (text: string, record: any) => {
            //         return <DisplayDate dateTime={record.metadata.creationTime} />
            //     }
            // },
            // {
            //     title: 'Signed In',
            //     dataIndex: 'creat',
            //     key: 'loginUserName',
            //     width: '15%',
            //     // tslint:disable-next-line:no-any
            //     render: (text: string, record: any) => {
            //         return <DisplayDate dateTime={record.metadata.lastSignInTime} />
            //     }
            // }
        ];
        return (
            <Table
                loading={loading}
                columns={this.columns}
                dataSource={ds}
                // onRow={this.handleOnRow}
                pagination={{
                    current: page || 0,
                    pageSize: this.pageSize,
                    total: ds.length || 0,
                    onChange: this.handlePageChange,
                    showTotal: (total) => <span className="total-count">Total Count: {total}</span>
                }}
                size="middle"
                bordered={true}
            />
        );
    }
}

export default connect(() => ({}), mapDispatchToProps)(UserList);


// WEBPACK FOOTER //
// ./src/merchants/forms/UserList.tsx